import inView from "./inView";

const lazyCount = () => {
  $(".js-count").each(function () {
    let $el = $(this);
    if (inView($el) && !$el.hasClass("loading")) {
      $el.addClass("loading");
      $el.prop("Counter", 0).animate(
        {
          Counter: $el.text(),
        },
        {
          duration: 2000,
          easing: "swing",
          step: function (now) {
            $el.text(Math.ceil(now).toLocaleString('th-TH'));
          },
        }
      );
    }
  });
};

export default lazyCount;
